import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ArenaGarden from "./components/ArenaGarden";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ArenaGarden />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
